/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface AdminUploadProfilePictureRequest {
  name: string | null;
  note: string | null;
  order: number | null;
  isPublic: boolean;
  mediaTypeId: number;
  assignedUserId: number;
  file: any | null;
  /** URL to the file to be uploaded. Saves time, since we can just reach out directly */
  fileUrl: string | null;
}
const AdminUploadProfilePictureRequest = {
  create: (initValues?: Partial<AdminUploadProfilePictureRequest> | null): AdminUploadProfilePictureRequest => {
    const defaults: AdminUploadProfilePictureRequest = {
      name: null,
      note: null,
      order: null,
      isPublic: false,
      mediaTypeId: 0,
      assignedUserId: 0,
      file: null,
      fileUrl: null,
    };
    const fixedValues: Partial<AdminUploadProfilePictureRequest> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default AdminUploadProfilePictureRequest;
